export default __webpack_public_path__ + "static/media/right-hand-pointing-left.ffa6a95f.png";